export const getSessionData = () => {
  try {
    const agentPersonInCharge = sessionStorage.getItem('agentPersonInCharge') || '';
    const agentName = sessionStorage.getItem('agentName') || '';
    const agencyEmail = sessionStorage.getItem('agencyEmail') || '';
    return { agentPersonInCharge, agentName, agencyEmail };
  } catch {
    return { agentPersonInCharge: '', agentName: '', agencyEmail: '' };
  }
};
